<script lang="ts">
  export let x: number, y: number;

  let w = Math.round(350 / x);
</script>

<div
  class="board"
  style={`grid-template-columns: repeat(${x}, ${w}px); grid-template-rows: repeat(${y}, ${w}px);`}
>
  <!-- {#each Array(y * x) as _} -->
  <slot />
  <!-- {/each} -->
</div>

<style>
  .board {
    width: 100%;
    display: grid;
  }
</style>
